import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ZbirniDnevnik } from './zbirni-dnevnik';

@Component({
  selector: 'app-zbirni-dnevnik-modal-update',
  templateUrl: './zbirni-dnevnik-modal-update.component.html'
})
export class ZbirniDnevnikModalUpdateComponent extends BaseModalUpdateComponent<ZbirniDnevnik> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<ZbirniDnevnik>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }


  ngOnInit() {
  }

}
